import { Play, ArrowUpRight, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";

const REELS = [
  { title: "Site Visit: 4BHK Penthouse", img: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&q=70&auto=format&fit=crop", message: "Hi! I saw your 4BHK Penthouse site visit reel — I'd like more details." },
  { title: "Drone Reveal: Gurugram Tower", img: "https://images.unsplash.com/photo-1551361415-69c87624334f?w=600&q=70&auto=format&fit=crop", message: "Hi! I saw your Gurugram tower drone reveal — please share project details." },
  { title: "Buyer Reaction: Plot Handover", img: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&q=70&auto=format&fit=crop", message: "Hi! Interested in your plot project — saw the handover reel." },
  { title: "Walkthrough: Builder Floor", img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=70&auto=format&fit=crop", message: "Hi! Saw your builder floor walkthrough — please share availability." },
  { title: "NRI Buyer: 'I Booked from Dubai'", img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=70&auto=format&fit=crop", message: "Hi! I'm an NRI investor — saw your Dubai booking reel and want to know more." },
  { title: "Channel Partner Activation", img: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&q=70&auto=format&fit=crop", message: "Hi! I'm a channel partner — saw your activation reel. Let's connect." },
];

export default function Reels() {
  return (
    <section id="reels" data-testid="reels-section" className="relative py-24 sm:py-32 border-t border-white/5 overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#d4ff4f]/5 blur-[140px]" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-8 mb-14">
          <div>
            <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#असली_रील्स</div>
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ UGC + Reels</div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
              Reels that actually<br />
              <span className="italic text-[#d4ff4f]">sell homes.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 text-base leading-relaxed self-end">
            Real walkthroughs, real buyer reactions, real handovers — shot, edited and amplified by our in-house creator team. <span className="text-[#d4ff4f]">Tap any reel to chat on WhatsApp.</span>
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto no-scrollbar pb-4 snap-x snap-mandatory">
          {REELS.map((r, i) => (
            <a
              key={i}
              href={waLink(r.message)}
              target="_blank"
              rel="noreferrer"
              data-testid={`reel-card-${i}`}
              className="snap-start group relative shrink-0 w-[260px] sm:w-[300px] aspect-[9/14] rounded-2xl overflow-hidden border border-white/10 card-hover"
            >
              <img src={r.img} alt={r.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />

              {/* Play overlay */}
              <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100">
                <div className="relative">
                  <div className="absolute inset-0 rounded-full bg-[#d4ff4f] blur-xl opacity-50 group-hover:opacity-100 transition" />
                  <div className="relative w-16 h-16 rounded-full bg-[#d4ff4f] flex items-center justify-center text-black group-hover:scale-110 transition pulse-ring">
                    <Play className="w-6 h-6 fill-black ml-1" />
                  </div>
                </div>
              </div>

              {/* WhatsApp hover hint */}
              <div className="absolute top-3 right-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#25D366] text-black text-[10px] font-semibold font-mono uppercase tracking-wider opacity-0 group-hover:opacity-100 transition translate-y-1 group-hover:translate-y-0">
                <MessageCircle className="w-3 h-3" /> WhatsApp
              </div>

              <div className="absolute bottom-0 inset-x-0 p-4">
                <div className="font-mono text-[10px] uppercase tracking-wider text-[#d4ff4f] mb-1">@DIGISAVVYY</div>
                <div className="font-display text-base tracking-tight leading-tight">{r.title}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4">
          <p className="text-sm text-white/50">→ Have a project ready to shoot? We send a crew anywhere in India within <span className="text-white">72 hours.</span></p>
          <a
            href="https://instagram.com/digisavvyy"
            target="_blank"
            rel="noreferrer"
            data-testid="reels-follow"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-[#d4ff4f] hover:text-white transition"
          >
            Follow @digisavvyy <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
